import RightArrowIconWhite from "../../../assets/icons/header-icons/right-arrow-white.svg";
import {
  fetchBalance,
  handleDemoLogin,
  login,
  loginSuccess,
  RootState,
  setLoading,
  useAppDispatch,
  useAppSelector,
  FORGOT_PASSWORD_ROUTE,
  REGISTER,
  getSapToken,
  showToast,
  ACCEPT_TERMS_ROUTE,
  RESET_PASSWORD_ROUTE,
  SIGN_UP_ROUTE,
} from "@hypexone/uicore";
import HeaderButtonComponent from "./HeaderButtonComponent";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoginPageBtn from "../login-page-btn/LoginPageBtn";
import handIcon from "../../../assets/images/hand-right.png";
import instagramIcon from "../../../assets/icons/instagram-icon.svg";
import telegramIcon from "../../../assets/icons/telegram-icon.svg";
import { isDesktop, isMobile } from "react-device-detect";
import SocialAuth from "../../pages/social-auth/SocialAuth";
import { BRAND_DOMAIN, BRAND_NAME } from "../../../constants/Branding";
import { authClient } from '../../../App';
import ResetTwoFactor from '../ResetTwoFactor/ResetTwoFactor';
import {
  getSocialContactUrl,
  getSupportContacts,
} from "../../../utils/socialContactUtils";
import { formInputClassName, formLabelClassName } from "../../../utils/formInputStyles";
interface LoginSectionProps {
  isHeader?: boolean;
  isMobileScreen?: boolean;
}

const LoginSection: React.FC<LoginSectionProps> = ({
  isMobileScreen = false,
  isHeader,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loginLoader, setLoginLoader] = useState(false);
  const [DemoLoginLoader, setDempLoginLoader] = useState(false);
  const { domainConfig } = useAppSelector((state) => state.common);
  const supportContacts = getSupportContacts(domainConfig);
  const instagramUrl = getSocialContactUrl(supportContacts, "INSTAGRAM_LINK");
  const telegramUrl = getSocialContactUrl(supportContacts, "TELEGRAM_NUMBER");
  // 2FA state
  const [show2FAInput, setShow2FAInput] = useState(false);
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [pendingLoginData, setPendingLoginData] = useState<any>(null);
  const [is2FALoading, setIs2FALoading] = useState(false);

  // Reset 2FA state
  const [showReset2FA, setShowReset2FA] = useState(false);

  const supportEmailId = `${BRAND_NAME}@gmail.com`;
  const { loading } = useAppSelector((state: RootState) => state.auth);
  const [LoginLoading, setLoginLoading] = useState(false);
  const [DemoLoading, setDemoLoading] = useState(false);
  const { loggedIn } = useAppSelector((state) => state.auth);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const { search } = useLocation();
  const authToken = new URLSearchParams(search).get("authToken");

  const setSapToken = async (token: string) => {
    await getSapToken(token);
  };

  useEffect(() => {
    if (authToken && authToken !== "null") {
      setSapToken(authToken);
      const username = authToken?.split(".")?.[1];
      let uname = JSON.parse(window?.atob(username)).sub;
      let uid = JSON.parse(window?.atob(username)).uid;
      sessionStorage.setItem("username", uname);
      sessionStorage.setItem("aid", uid);
      sessionStorage.setItem("jwt_token", authToken);
      let claim = authToken.split(".")[1];
      sessionStorage.setItem("aid", JSON.parse(window.atob(claim)).aid);
      dispatch(loginSuccess(authToken));
      navigate("/home");
      // dispatch(fetchBalance());
    }
  }, [authToken]);

  const handleLogin = async () => {
    setLoginLoader(true);
    dispatch(setLoading(true));
    try {
      const userInput = userName.trim().toLowerCase();

        const loginRequest = {
          username: userInput,
          password: password.trim(),
          navigate,
        };

        console.log("loginRequest:", loginRequest);

        dispatch(setLoading(true));

        // Use UICore login thunk which handles 2FA detection internally
        const response = await dispatch(
          login({
            ...loginRequest,
            navigate,
          })
        ).unwrap();

        // Check if 2FA is required
        if (response?.requires2FA) {
          // Two-Factor Authentication required
          setPendingLoginData({
            ...loginRequest,
            userInput: userInput,
            password: password,
          });
          setShow2FAInput(true);
          dispatch(setLoading(false));
          return;
        }

        dispatch(setLoading(false));
    } catch (err) {
      console.log("Login error:", err);
      dispatch(showToast({ type: 'error', message: err?.response?.data?.message || 'Failed to login' }));
    } finally {
      setLoginLoading(false);
    }

    // }

    dispatch(setLoading(false));
    setLoginLoader(false)
  };
  useEffect(() => {
    if (loggedIn) {
      const claim = sessionStorage.getItem("jwt_token").split(".")[1];
      let status = JSON.parse(window.atob(claim)).sts;

      if (status === 2) {
        navigate(ACCEPT_TERMS_ROUTE, { replace: true });
      } else if (status === 4) {
        navigate(RESET_PASSWORD_ROUTE, { replace: true });
      }
    }
  }, [loggedIn]);

  const handleForgotPassClick = () => {
    navigate(FORGOT_PASSWORD_ROUTE);
  };

  const handleResendEmailClick = () => {
    navigate('/resend-email');
  }
  const handleSignUpClick = () => {
    navigate(REGISTER);
  };

  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };
  const { langData } = useAppSelector((state) => state.cms);

  const handle2FASubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!pendingLoginData || !twoFactorCode.trim()) return;

    try {
      setIs2FALoading(true);

      const loginRequest = {
        username: pendingLoginData.username,
        password: pendingLoginData.password,
        otp: twoFactorCode,
        loginRequestType: "TWO_FACTOR_SIGN_IN",
      };

      await dispatch(
        login({
          ...loginRequest,
          navigate,
        })
      ).unwrap();

      // Reset state on success
      setShow2FAInput(false);
      setPendingLoginData(null);
      setTwoFactorCode("");
      setIs2FALoading(false);
    } catch (err) {
      setIs2FALoading(false);
      dispatch(showToast({ type: 'error', message: err?.response?.data?.message || 'Failed to login' }));
    }
  };

  const handle2FABack = () => {
    setShow2FAInput(false);
    setPendingLoginData(null);
    setTwoFactorCode("");
    setIs2FALoading(false);
  };

  const formatOTPInput = (value: string) => {
    const numericValue = value.replace(/\D/g, "").slice(0, 6);
    return numericValue;
  };

  const handleOTPChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatOTPInput(e.target.value);
    setTwoFactorCode(formattedValue);
  };

  // Reset 2FA handlers
  const handleReset2FABack = () => {
    setShowReset2FA(false);
  };

  const handleReset2FASuccess = () => {
    setShowReset2FA(false);
    setShow2FAInput(false);
    setPendingLoginData(null);
    setTwoFactorCode("");
  };

  return (
    <div
      className={`items-center ${isMobileScreen
        ? "flex flex-col w-full gap-2"
        : "hidden md:flex gap-1 w-auto ml-1 shrink-0"
        }`}
    >
      <div className={`relative ${isMobileScreen ? "flex w-full flex-col gap-1.5" : "flex items-center gap-2"}`}>
          {isMobileScreen ? (
            <>
              <div className="w-full">
                <label htmlFor="loginUsername" className={formLabelClassName}>
                  {langData?.["username"] ?? "Username"}
                </label>
                <input
                  id="loginUsername"
                  placeholder={langData?.["enter_username_txt"] ?? "Enter username"}
                  className={formInputClassName}
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  onKeyDown={handleEnterKeyPress}
                />
              </div>
              <div className="w-full">
                <label htmlFor="loginPassword" className={formLabelClassName}>
                  {langData?.["password"] ?? "Password"}
                </label>
                <input
                  id="loginPassword"
                  type="password"
                  placeholder={langData?.["enter_password"] ?? "Enter Password"}
                  className={formInputClassName}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={handleEnterKeyPress}
                />
              </div>
            </>
          ) : (
            <>
              <input
                placeholder="Username"
                className="h-[25px] rounded-[5px] px-4 text-[15px] outline-none placeholder-black md:w-[120px] lg:w-[200px] md:placeholder-gray-400 md:placeholder:not-italic placeholder:italic"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                onKeyDown={handleEnterKeyPress}
              />
              <input
                type="password"
                placeholder="Password"
                className="h-[25px] rounded-[5px] px-4 text-[15px] outline-none placeholder-black md:w-[120px] lg:w-[200px] md:placeholder-gray-400 md:placeholder:not-italic placeholder:italic"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleEnterKeyPress}
              />
            </>
          )}
          {
            isMobile && <div className="mb-2 mt-2">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="customCheck2"
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label
                  htmlFor="customCheck2"
                  className="ml-2 block text-[12px] font-[600] font-sans text-white"
                >
                  Remember me
                </label>
              </div>

              {/* <small className="text-[12px] font-sans text-white mt-1 block">
                This site is protected by reCAPTCHA and the Google
                <a href="#" className="text-white underline ml-1">Privacy Policy</a> and
                <a href="#" className="text-white underline ml-1">Terms of Service apply</a>.
              </small> */}
            </div>


          }
          {isMobileScreen && (
            <div className="w-full flex justify-end text-nowrap text-[10px] flex-col mt-1">
              {domainConfig.b2cEnabled && (
                <div
                  onClick={handleForgotPassClick}
                  className="text-white cursor-pointer mr-1"
                >
                  {langData?.['forgot_password']}?
                </div>
              )}
              <div
                onClick={handleResendEmailClick}
                className="text-white text-[10px] cursor-pointer mr-1"
              >
                {langData?.['resend_email'] || 'Resend Verification email'}?
              </div>
            </div>
          )}
          {isHeader ? (
            <>
              <HeaderButtonComponent
                rightIcon={{ src: RightArrowIconWhite, alt: "right-arrow" }}
                customCSS={isMobileScreen ? "w-full" : ""}
                onClick={handleLogin}
                buttonVariant="login"
                buttonText={"Login"}
                loading={loginLoader}
              />
              {domainConfig.b2cEnabled && (
                <HeaderButtonComponent
                  rightIcon={{ src: RightArrowIconWhite, alt: "right-arrow" }}
                  customCSS={isMobileScreen ? "w-full" : ""}
                  onClick={handleSignUpClick}
                  buttonVariant="signup"
                  buttonText={langData?.["sign_up"] ?? langData?.["signup"] ?? "Sign Up"}
                />
              )}
    
              {domainConfig.demoUser && <HeaderButtonComponent
                rightIcon={{ src: RightArrowIconWhite, alt: "right-arrow" }}
                customCSS={isMobileScreen ? "w-full" : "w-full"}
                onClick={() => { dispatch(handleDemoLogin(navigate)); setDempLoginLoader(true) }}
                isRedButton
                buttonText={"Login With Demo ID"}
                loading={DemoLoginLoader}
              />}
              {domainConfig?.signup && domainConfig?.oauth_enabled && (
                <div className="flex items-center justify-center text-[10px] font-[500]  gap-1">
                  <div className="text-white text-nowrap text-[10px] flex-col mt-1">or </div>
                  <SocialAuth />
                </div>
              )}
    
            </>
          ) : (
            <>
              <LoginPageBtn
                loading={loginLoader}
                onClick={handleLogin}
                label={"Login"}
              />
              <LoginPageBtn
                loading={DemoLoginLoader}
                onClick={() => dispatch(handleDemoLogin(navigate))}
                label={"Login With Demo ID"}
              />
              {domainConfig?.signup && domainConfig?.oauth_enabled && (
                <div className="flex flex-col items-center justify-center text-[10px] font-[500]  gap-2 mb-2">
                  <div className="text-white text-nowrap text-[10px] flex-col mt-1">or continue with </div>
                  <SocialAuth />
                </div>
              )}
              {/* <div>
                 <div
                  onClick={handleResendEmailClick}
                  className={`text-white cursor-pointer  mr-1`}
                >
                  {langData?.['resend_email'] || 'Resend Verification email'}?
                </div>
              </div> */}
              {!isHeader && (
                <>
                  <div className="w-full flex justify-center">
                    <a
                      href={`mailto:${supportEmailId}`}
                      className="text-white cursor-pointer text-xs uppercase"
                    >
                      {supportEmailId}
                    </a>
                  </div>
    
                  {domainConfig.b2cEnabled && (
                    <div className="w-full flex justify-center">
                      <div className="text-white">
                        <span className="xl:hidden"> {langData?.['no_account']}</span>
                        <span
                      onClick={handleSignUpClick}
                          className="cursor-pointer text-[#ffff00] font-bold"
                        >
                          {langData?.['sign_up']}
                        </span>
                      </div>
                    </div>
                  )}
                  {(instagramUrl || telegramUrl) && (
                  <div className="border-t border-dashed border-white w-full pt-4 mt-2">
                    <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 px-1">
                      <div className="animate-slightLeftRightInfinite shrink-0">
                        <img
                          alt="right-hand"
                          className="w-7 object-cover sm:w-8"
                          src={handIcon}
                        />
                      </div>
                      {instagramUrl && (
                        <a
                          target="_blank"
                          href={instagramUrl}
                          className="flex items-center shrink-0"
                          rel="noreferrer"
                        >
                          <img
                            alt="instagram-icon"
                            className="w-7 object-cover sm:w-8"
                            src={instagramIcon}
                          />
                          <div className="text-white font-bold uppercase ml-1 text-xs sm:text-sm">
                            {langData?.['instagram'] || "Instagram"}
                          </div>
                        </a>
                      )}
                      {telegramUrl && (
                        <a
                          target="_blank"
                          href={telegramUrl}
                          className="flex items-center shrink-0"
                          rel="noreferrer"
                        >
                          <img
                            alt="telegram-icon"
                            className="w-7 object-cover sm:w-8"
                            src={telegramIcon}
                          />
                          <div className="text-white font-bold uppercase ml-1 text-xs sm:text-sm">
                            {langData?.['telegram']}
                          </div>
                        </a>
                      )}
                    </div>
                  </div>
                  )}
                </>
              )}
            </>
          )}
      </div>

      {show2FAInput && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
          <div className="w-full max-w-[460px] rounded-lg bg-[#1f2a52] p-4 md:p-6">
            {showReset2FA ? (
              <ResetTwoFactor
                langData={langData}
                onBack={handleReset2FABack}
                onSuccess={handleReset2FASuccess}
                pendingLoginData={pendingLoginData}
                navigate={navigate}
              />
            ) : (
              <form
                onSubmit={handle2FASubmit}
                className="login-form-ctn flex flex-col gap-4 rounded-lg w-full"
                autoComplete="off"
              >
                <div
                  className="back-icon cursor-pointer"
                  onClick={handle2FABack}
                >
                  <div className="back flex items-center gap-2">
                    {/* <img src={BackArrow} className="arrow-clr w-5 h-5" alt="back" /> */}
                    <span className="back-text text-white hover:text-gray-200 transition-colors">
                      {langData?.["back"]}
                    </span>
                  </div>
                </div>

                <div className="card-title text-xl font-bold text-white">
                  {langData?.["two_factor_auth"] || "Two-Factor Authentication"}
                </div>
                <span className="card-login-here block text-white leading-relaxed">
                  {langData?.["2fa_login_description"] ||
                    "Enter the 6-digit code from your authenticator app"}
                </span>

                <div className="code-input w-full">
                  <label className="input-labell block font-semibold mb-2 text-white uppercase text-sm">
                    {langData?.["2fa_otp_label"] || "Authentication Code"}{" "}
                    <span className="red-text text-red-500">*</span>
                  </label>
                  <input
                    className="login-input-field user-name w-full px-4 py-3 border border-white rounded-lg bg-transparent text-center text-lg tracking-widest font-mono text-white placeholder-white/20 placeholder:text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-300 transition-all duration-200"
                    type="text"
                    value={twoFactorCode}
                    onChange={handleOTPChange}
                    placeholder="Enter code"
                    maxLength={6}
                  />
                </div>

                <div className="login-demologin-btns">
                  <button
                    className="login-form-btn-without-demologin w-full h-12 rounded-xl font-semibold text-base normal-case shadow-[0_4px_12px_rgba(79,209,197,0.3)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_6px_16px_rgba(79,209,197,0.4)] disabled:translate-y-0 disabled:shadow-none disabled:opacity-60 bg-blue-600 hover:bg-blue-700 text-white"
                    type="submit"
                    disabled={is2FALoading || twoFactorCode.length !== 6}
                  >
                    {is2FALoading
                      ? "Loading..."
                      : langData?.["verify_and_login"] || "Verify & Login"}
                  </button>
                </div>

                <div className="reset-2fa-link-section text-center">
                  <button
                    type="button"
                    className="reset-2fa-link text-white hover:text-gray-200 underline font-medium transition-colors duration-200"
                    onClick={() => setShowReset2FA(true)}
                  >
                    {langData?.["reset_two_factor_auth"] ||
                      "Reset Two-Factor Authentication"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

    </div>
  );
};

export default LoginSection;